import styled from 'styled-components';

const LeaseDescription = styled.a`
  color: ${(props): string => props.theme.colors.lqBlue};
  text-decoration: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  max-width: calc(32vw - 4rem);
`;

export { LeaseDescription };
